import React from 'react';
import { useIntl } from 'react-intl';

interface FieldProps {
  labelKey?: string;
  label?: string;
  value?: string | number | null | React.ReactNode;
}

export const Field = ({ labelKey, label, value }: FieldProps) => {
  const intl = useIntl();
  const displayLabel = label ?? intl.formatMessage({ id: labelKey! });

  return (
    <div className={'field'}>
      <div className="label">{displayLabel}: </div>
      <div className="value">{value}</div>
    </div>
  );
};
